import React from 'react';
import PropTypes from 'prop-types';
import PlusIcon from '../../icons/icon-plus.svg';
import MinusIcon from '../../icons/icon-minus.svg';


const QuantitySelector = function QuantitySelectorComponent({
  min,
  max,
  disabled,
  current,
  options,
  onChange,
}) {
  return (
    <div className="quantity-select__wrapper">
      <button
        type="button"
        className="quantity-select__control"
        disabled={disabled || current <= min}
        onClick={() => onChange(current - 1, options)}
      >
        <MinusIcon className="quantity-select__icon-minus" />
        <span className="quanty-select__helper-text">Remove one</span>
      </button>
      <span className="quantity-select__display">
        {current}
      </span>
      <button
        type="button"
        className="quantity-select__control"
        disabled={disabled || current >= max}
        onClick={() => onChange(current + 1, options)}
      >
        <PlusIcon className="quantity-select__icon-plus" />
        <span className="quanty-select__helper-text">Add one</span>
      </button>
    </div>
  );
};

QuantitySelector.propTypes = {
  current: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  options: PropTypes.shape({}),
  disabled: PropTypes.bool,
};

QuantitySelector.defaultProps = {
  current: 1,
  min: -Infinity,
  max: Infinity,
  onChange: () => {},
  options: {},
  disabled: false,
};

export default QuantitySelector;
